import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContractSummaryComponent } from './contract-summary/contract-summary.component';
import { ContractAddComponent } from './contract-add/contract-add.component';

const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'Contract'
    },
    children: [
      {
        path: 'summary',
        component: ContractSummaryComponent,
        data: {
          title: 'Summary'
        }
      },
      {
        path: 'add',
        component: ContractAddComponent,
        data: {
          title: 'Add'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContractRoutingModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/contract/contract-routing.module.ts